import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customTitleCasePipe',
  standalone: true
})
export class CustomTitleCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;

    if (value.toLowerCase() === 'quicksight') {
      return 'QuickSight';
    }
   


    return value.replace(/\b\w/g, (char) => char.toUpperCase());
  }

}
